import React from 'react'
import { Backdrop, CircularProgress } from '@mui/material'

interface FullScreenLoadingProps {
  open: boolean
}

const FullScreenLoading: React.FC<FullScreenLoadingProps> = ({ open }) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
      open={open}
    >
      <CircularProgress color="primary" />
    </Backdrop>
  )
}

export default FullScreenLoading
